import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'sd-switch-control',
  templateUrl: './switch-control.component.html',
  styleUrls: ['../../assets/css/label.scss']
})
export class SwitchControlComponent implements OnInit {
  @Input() label: string;
  @Input() color: 'primary' | 'warn' = 'primary';
  @Input() disabled: boolean;

  cModel: any;
  @Input() set model(value: any) {
    this.ref.detectChanges();
    this.cModel = value;
  }

  @Output() modelChange = new EventEmitter();

  @Output() change = new EventEmitter();
  @Output() sdChange = new EventEmitter();
  constructor(private ref: ChangeDetectorRef) {
  }

  ngOnInit() {
  }
  onChange(value: any) {
    this.cModel = value;
    this.modelChange.emit(this.cModel);
    this.change.emit(this.cModel);
    this.sdChange.emit(this.cModel);
  }
}
